
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import useVias from '../../hooks/useVias';
import '../../styles/ubicacion/busquedaVia.css';

const BusquedaVia = ({ onViaSeleccionada, modoUbicacion }) => {
  const { vias, loading, error } = useVias();
  const [viaSeleccionada, setViaSeleccionada] = useState(null);
  const [referencia, setReferencia] = useState('');
  const [direccionCompleta, setDireccionCompleta] = useState('');
  const [mostrarDireccionCompleta, setMostrarDireccionCompleta] = useState(false);

  useEffect(() => {
    if (viaSeleccionada && referencia) {
      const direccion = `${viaSeleccionada.tipo_via_display} ${viaSeleccionada.via_chNombre} Cuadra ${viaSeleccionada.via_inCuadra}${referencia ? `, ${referencia}` : ''}`;
      setDireccionCompleta(direccion);
    }
  }, [viaSeleccionada, referencia]);

  const opcionesVias = vias.map(via => ({
    value: via.id,
    label: `${via.tipo_via_display} ${via.via_chNombre} Cuadra ${via.via_inCuadra}`,
    via: via
  }));

  const handleViaChange = (opcion) => {
    if (opcion) {
      setViaSeleccionada(opcion.via);
      setReferencia('');
      setMostrarDireccionCompleta(false);
      onViaSeleccionada(opcion.via, opcion.value);
    } else {
      setViaSeleccionada(null);
      setReferencia('');
      setDireccionCompleta('');
      setMostrarDireccionCompleta(false);
      onViaSeleccionada(null, null);
    }
  };

  const handleConfirmarSeleccion = () => {
    if (viaSeleccionada && direccionCompleta) {
      setMostrarDireccionCompleta(true);
      
      // Actualizar la dirección completa en el componente padre
      const direccionCompletaConReferencia = `${viaSeleccionada.tipo_via_display} ${viaSeleccionada.via_chNombre} Cuadra ${viaSeleccionada.via_inCuadra}${referencia ? `, ${referencia}` : ''}`;
      
      // Llamar a onViaSeleccionada con la vía y la dirección completa actualizada
      onViaSeleccionada({
        ...viaSeleccionada,
        direccionCompleta: direccionCompletaConReferencia
      }, viaSeleccionada.id);
    }
  };

  const handleReferenciaChange = (e) => {
    setReferencia(e.target.value);
  };

  if (loading) return <div className="loading">Cargando vías...</div>;
  if (error) return <div className="error">Error al cargar vías: {error}</div>;

  return (
    <div className="busqueda-via-container">
      <Select
        className="via-select"
        classNamePrefix="via-select"
        options={opcionesVias}
        onChange={handleViaChange}
        placeholder="Buscar vía..."
        isClearable
        isSearchable
        noOptionsMessage={() => "No se encontraron vías"}
        loadingMessage={() => "Buscando..."}
      />

      {viaSeleccionada && (
        <div className="via-info-card">
          <div className="via-details">
            <h4>Vía Seleccionada:</h4>
            <p><strong>Tipo:</strong> {viaSeleccionada.tipo_via_display}</p>
            <p><strong>Nombre:</strong> {viaSeleccionada.via_chNombre}</p>
            <p><strong>Cuadra:</strong> {viaSeleccionada.via_inCuadra}</p>
            <p><strong>Coordenadas:</strong> {viaSeleccionada.via_deLatitud}, {viaSeleccionada.via_deLongitud}</p>
          </div>
          
          <div className="completar-direccion-container">
            <label htmlFor="completar-direccion">Completar dirección:</label>
            <input
              id="completar-direccion"
              type="text"
              value={referencia}
              onChange={handleReferenciaChange}
              placeholder="Ej: s2p piso mab n lt 5..."
              className="completar-direccion-input"
            />
          </div>

          {referencia && (
            <div className="acciones-container">
              <button 
                onClick={handleConfirmarSeleccion}
                className="btn-confirmar"
                disabled={!referencia.trim()}
              >
                Confirmar Selección
              </button>
            </div>
          )}
        </div>
      )}

      {mostrarDireccionCompleta && direccionCompleta && (
        <div className="direccion-completa-card">
          <h4>Dirección Completa:</h4>
          <p className="direccion-texto">{direccionCompleta}</p>
          <small>Esta dirección será enviada al campo de ubicación de la incidencia</small>
        </div>
      )}
    </div>
  );
};

export default BusquedaVia;
